import { SeoRenderer } from "../../../common/helpers/seo";
import GameAdmin from "./loadable";

export default {
    component: GameAdmin,
    renderSeo: ({ dispatch }, allMessage, lang) => {
        SeoRenderer({ title: "Game admin", allMessage, lang });
    },
}